module.exports = __webpack_public_path__ + "img/icon-shield.c1a19951.svg";